<template>
  <div>
    <orders-notification :display="displayRequired"></orders-notification>

    <v-dialog v-model="edit" max-width="600px">
      <v-card class="pb-2">
        <v-card-title>
          <v-title>Advanced Order Details</v-title>
        </v-card-title>
        <v-card-text>
          <v-layout row>
            <v-flex xs12 md12 lg12>
              <vonex-select
                v-model="editedOrder.orderStatus"
                :items="orderStatuses"
                box
                label="Status"
                name="editedOrderStatus"
                item-text="text"
                item-value="value"
                :options="fieldConditions"
              ></vonex-select>
              <!-- <v-select
                :items="orderStatuses"
                v-model="editedOrder.orderStatus"
                box
                label="Status"
                name="editedOrderStatus"
                item-text="text"
                item-value="value"
              ></v-select> -->
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 md12 lg12>
              <vonex-select
                v-model="editedOrder.orderType"
                :items="typeItems"
                box
                label="Type"
                name="editedOrderType"
                item-text="text"
                item-value="text"
                :options="fieldConditions"
              ></vonex-select>
              <!-- <v-select
                :items="typeItems"
                v-model="editedOrder.orderType"
                box
                label="Type"
                name="editedOrderType"
                item-text="text"
                item-value="text"
              ></v-select> -->
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 md12 lg12>
              <vonex-text
                ref="ticketNo"
                :value="editedOrder.kayakoConversation"
                label="Ticket #"
                mask="##########"
                name="kayakoConversation"
                :options="fieldConditions"
                @input="updateTicketValue($event)"
              ></vonex-text>
              <!-- <v-text-field
                :value="editedOrder.kayakoConversation"
                @input="updateTicketValue($event)"
                ref="ticketNo"
                label="Ticket #"
                mask="##########"
                name="kayakoConversation"
              ></v-text-field> -->
            </v-flex>
          </v-layout>

          <v-layout v-if="editedOrder.envelopeID" row>
            <v-flex xs12 md12 lg12>
              <vonex-text
                v-model="editedOrder.envelopeID"
                label="Envelope ID"
                name="envelopeID"
                :options="fieldConditions"
              ></vonex-text>
              <!-- <v-text-field
                v-model="editedOrder.envelopeID"
                label="Envelope ID"
                name="envelopeID"
              ></v-text-field> -->
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-btn color="primary" @click.native="reset = true">
            Reset To Edit
          </v-btn>
          <v-btn
            v-if="editedOrder.envelopeID"
            color="primary"
            @click.native="reprocessOrder"
          >
            Reprocess
          </v-btn>
          <v-btn
            v-if="editedOrder.envelopeID"
            color="primary"
            title="this will send files from Docusign envelope to Zammad"
            @click.native="uploadToTicket"
          >
            Upload Files
            <br />
            to Ticket
          </v-btn>
          <vonex-checkbox
            v-show="reset"
            label="Reset - Check this box if you are sure?"
            :options="fieldConditions"
            :input-value="false"
            @change="resetToEdit(editedOrder)"
          ></vonex-checkbox>
          <!-- <v-checkbox
            v-show="reset"
            label="Reset - Check this box if you are sure?"
            @change="resetToEdit(editedOrder)"
            :value="false"
          ></v-checkbox> -->
          <v-spacer></v-spacer>
          <v-btn
            v-show="!reset"
            color="primary"
            @click.native="saveEditedOrder()"
          >
            Save
          </v-btn>
          <v-btn color="light-grey" @click.native="edit = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div style="padding-top: 10px">
      <v-layout row>
        <v-flex xs2 md2 lg2>
          <vonex-checkbox
            v-model="selectQuote"
            :input-value="selectQuote"
            :label="`Quote`"
            :options="fieldConditions"
          ></vonex-checkbox>
          <!-- <v-checkbox :label="`Quote`" v-model="selectQuote"></v-checkbox> -->
        </v-flex>
        <v-flex xs2 md2 lg2>
          <vonex-checkbox
            v-model="chk0"
            :input-value="chk0"
            :label="`New`"
            :options="fieldConditions"
          ></vonex-checkbox>
          <!-- <v-checkbox :label="`New`" v-model="chk0"></v-checkbox> -->
        </v-flex>
        <v-flex xs2 md2 lg2>
          <vonex-checkbox
            v-model="chk1"
            :input-value="chk1"
            :label="`In Progress`"
            :options="fieldConditions"
          ></vonex-checkbox>
          <!-- <v-checkbox :label="`In Progress`" v-model="chk1"></v-checkbox> -->
        </v-flex>
        <v-flex xs2 md2 lg2>
          <vonex-checkbox
            v-model="chk2"
            :input-value="chk2"
            :label="`Signed`"
            :disabled="orderType === 'Attention Required'"
            :options="fieldConditions"
          ></vonex-checkbox>
          <!-- <v-checkbox
            :label="`Signed`"
            v-model="chk2"
            :disabled="orderType === 'Attention Required'"
          ></v-checkbox> -->
        </v-flex>
        <v-flex xs2 md2 lg2>
          <vonex-checkbox
            v-model="chk3"
            :input-value="chk3"
            :label="`Completed`"
            :disabled="orderType === 'Attention Required'"
            :options="fieldConditions"
          ></vonex-checkbox>
          <!-- <v-checkbox
            :label="`Completed`"
            v-model="chk3"
            :disabled="orderType === 'Attention Required'"
          ></v-checkbox> -->
        </v-flex>

        <v-flex xs2 md2 lg2>
          <vonex-checkbox
            v-model="chk4"
            :input-value="chk4"
            :label="`Cancelled`"
            :disabled="orderType === 'Attention Required'"
            :options="fieldConditions"
          ></vonex-checkbox>
          <!-- <v-checkbox
            :label="`Cancelled`"
            v-model="chk4"
            :disabled="orderType === 'Attention Required'"
          ></v-checkbox> -->
        </v-flex>
        <v-flex xs2 md2 lg2>
          <vonex-checkbox
            v-model="chk5"
            :input-value="chk5"
            :label="`Rejected`"
            :disabled="orderType === 'Attention Required'"
            :options="fieldConditions"
          ></vonex-checkbox>
          <!-- <v-checkbox
            :label="`Rejected`"
            v-model="chk5"
            :disabled="orderType === 'Attention Required'"
          ></v-checkbox> -->
        </v-flex>

        <v-flex xs3>
          <vonex-select
            v-model="orderType"
            :items="orderTypes"
            label="Filter Order Type"
            :options="fieldConditions"
          ></vonex-select>
          <!-- <v-select
            :items="orderTypes"
            v-model="orderType"
            label="Filter Order Type"
          ></v-select> -->
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-layout row>
        <v-flex xs4>
          <vonex-text
            v-model="SearchTextOrderTable"
            name="Search"
            label="Search"
            append-icon="search"
            :options="fieldConditions"
          ></vonex-text>
          <!-- <v-text-field
            name="Search"
            label="Search"
            v-model="SearchTextOrderTable"
            append-icon="search"
          ></v-text-field> -->
        </v-flex>
        <v-spacer></v-spacer>
        <v-combobox
          v-if="showDealerDropdown"
          v-model="selectedDealer"
          label="Search a dealer"
          name="Selected Dealer"
          :items="dealers"
          :item-text="dealerText"
          clearable
          @change="updateOrders"
        ></v-combobox>

        <!-- <vonex-text
          v-if="isAdmin"
          v-model="filterDealerID"
          name="searchDealerID"
          label="Search by Dealer ID"
          append-icon="search"
          :options="fieldConditions"
        ></vonex-text> -->
        <!-- <v-text-field
          v-if="isAdmin"
          name="searchDealerID"
          label="Search by Dealer ID"
          v-model="filterDealerID"
          append-icon="search"
        ></v-text-field> -->
      </v-layout>
    </div>
    <div>
      <v-spacer></v-spacer>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="allFlags.SOG3400 ? orderData : filteredRows"
        :pagination.sync="pagination"
        :loading="loading"
        :total-items="paginatedData.total"
        :mustSort="true"
      >
        <v-progress-linear
          slot="progress"
          color="blue"
          indeterminate
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  :data-cy-restore="props.item.orderID"
                  flat
                  icon
                  :color="props.item.isQuote ? '#2f5578' : 'secondary'"
                  @click="existingOrder(props.item)"
                  v-on="on"
                >
                  <v-icon v-if="props.item.isQuote">monetization_on</v-icon>
                  <v-icon v-else>restore</v-icon>
                </v-btn>
              </template>
              <span>{{ props.item.isQuote ? 'See Quote' : 'Show Order' }}</span>
            </v-tooltip>
          </td>
          <td>{{ props.item.orderID }}</td>
          <td v-if="isAdmin">{{ props.item.ubDealerID }}</td>
          <td>{{ props.item.dealerFullName }}</td>
          <!-- <td class="text-md-right">{{ props.item.createdDate | formatDate }}</td> -->
          <td class="text-md-right">
            {{ props.item.updatedDate | formatDate }}
          </td>
          <td class="text-md-right">
            <div v-if="props.item.orderStatus == 2">
              {{ props.item.signedDate | formatDate }}
            </div>
          </td>
          <td class="text-md-right">{{ props.item.orderString }}</td>
          <td class="text-md-right">
            {{ props.item.orderStatus | orderStatus }}
          </td>
          <td class="text-md-right">
            <a :href="getTicketLink(props)" target="_blank">
              {{ props.item.kayakoConversation }}
            </a>
          </td>
          <td v-if="isAdmin" class="text-sm-right">
            <v-btn flat icon color="green" @click="setEditedOrder(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
          <td class="text-sm-right">
            <v-btn
              v-if="props.item.orderStatus <= 1"
              flat
              icon
              color="red"
              @click="cancelOrder(props.item.orderID)"
            >
              <v-icon>cancel</v-icon>
            </v-btn>
          </td>

          <td v-if="isAdmin" class="text-sm-right">
            <v-btn
              v-if="props.item.orderStatus === 2"
              flat
              icon
              color="red"
              @click="resubmitOrder(props.item.orderID)"
            >
              <v-icon>submit</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import OrdersNotification from './orders-notification';
const { mapGetters: mapOrderGetters } = createNamespacedHelpers(`orders`);
const { mapState: mapDealerState } = createNamespacedHelpers('orders/dealer');
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);

export default {
  name: 'OrdersTable1723',
  components: { OrdersNotification },
  props: {
    orderData: Array,
    paginatedData: Object,
    loading: Boolean,
    attention: Boolean,
  },
  data() {
    return {
      dealers: [],
      selectedDealer: null,
      reset: false,
      chk0: true,
      chk1: true,
      chk2: false,
      chk3: false,
      chk4: false,
      chk5: false,
      edit: false,
      selectQuote: false,
      orderTypes: ['All', 'Normal', 'ChangeAddress', 'ChangeLessee', 'Qantas'],
      displayRequired: false,
      orderType: 'All',
      typeItems: ['Normal', 'Qantas'],
      filterDealerID: undefined,
      editedOrder: [],
      SearchTextOrderTable: null,
      pagination: {
        rowsPerPage: 10,
        descending: true,
      },
      ticketNo: null,
      headers: [
        {
          text: 'Retrieve',
          align: 'left',
          sortable: false,
          value: 'true',
        },
        {
          text: 'ID',
          align: 'left',
          sortable: true,
          value: 'orderID',
        },
        {
          text: 'Dealer Name',
          align: 'right',
          sortable: false,
          value: 'true',
        },
        {
          text: 'Modified Date',
          align: 'right',
          sortable: true,
          value: 'updatedDate',
        },
        {
          text: 'Signed Date',
          align: 'right',
          sortable: true,
          value: 'signedDate',
        },
        {
          text: 'Customer / Company',
          align: 'right',
          sortable: false,
          //value: 'customerDetails.surname'
        },
        {
          text: 'Status',
          align: 'right',
          sortable: true,
          value: 'orderStatus',
        },

        {
          text: 'Ticket#',
          align: 'right',
          sortable: false,
          value: 'true',
        },
        {
          text: 'Cancel Order',
          align: 'right',
          sortable: false,
          value: 'true',
        },
        {
          text: 'Resubmit Order',
          align: 'right',
          sortable: false,
          value: 'true',
        },
      ],
      orderStatuses: [
        { text: 'New', value: 0 },
        { text: 'In Progress', value: 1 },
        { text: 'Signed', value: 2 },
        { text: 'Completed', value: 3 },
        { text: 'Cancelled', value: 4 },
        { text: 'Rejected', value: 5 },
      ],
    };
  },
  methods: {
    ...mapActions('impersonate', ['getDealerMembers']),
    showDealerDropdown() {
      let user_email_domain = this.$auth.user.name.split('@').pop();
      if (user_email_domain == 'vonex.com.au') return true;
      return false;
    },
    dealerText(val) {
      return `${val.ubDealerID} (${val.email})`;
    },
    updateOrders(dealer) {
      this.selectedDealer = dealer;
      this.emitRequest();
    },
    reprocessOrder: function () {
      this.$emit('reprocessOrder', this.editedOrder.envelopeID);
    },
    uploadToTicket: function () {
      this.$emit('uploadToTicket', this.editedOrder.orderID);
    },
    showOrdersForAttention() {
      this.displayRequired = !this.displayRequired;
    },
    existingOrder: function (order) {
      this.$emit('existingOrder', order);
    },
    setEditedOrder(order) {
      let vm = this;
      vm.edit = true;
      vm.reset = false;
      vm.editedOrder = order;
    },
    resetToEdit() {
      let vm = this;
      vm.editedOrder.kayakoConversation = vm.ticketNo;
      this.$emit('resetToEdit', vm.editedOrder);
      vm.edit = false;
    },
    saveEditedOrder() {
      let vm = this;
      vm.editedOrder.kayakoConversation = vm.ticketNo;
      this.$emit('update', vm.editedOrder);
      vm.edit = false;
    },
    cancelOrder: function (orderID) {
      this.$emit('cancelOrder', orderID);
    },
    resubmitOrder(orderID) {
      this.$emit('resubmitOrder', orderID);
    },
    isValid: function (order) {
      let vm = this;

      const filters = [];
      for (var i = 0; i < 7; i++) {
        if (vm['chk' + i]) filters.push(i);
      }

      if (!filters.includes(order.orderStatus)) return false;
      if (vm.SearchTextOrderTable === null) return true;

      if (vm.SearchTextOrderTable != null) {
        if (
          order &&
          order.dealerFullName &&
          order.dealerFullName
            .toUpperCase()
            .includes(vm.SearchTextOrderTable.toUpperCase()) &&
          filters.includes(order.orderStatus)
        )
          return true;
      }

      if (order.orderID.toString().includes(vm.SearchTextOrderTable))
        return true;
      if (order.orderString !== null)
        if (
          order.orderString
            .toUpperCase()
            .includes(vm.SearchTextOrderTable.toUpperCase())
        )
          return true;
    },
    updateTicketValue(event) {
      let vm = this;
      vm.ticketNo = event;
    },
    emitRequest() {
      let vm = this;
      const filters = [];
      for (var i = 0; i < 7; i++) {
        if (vm['chk' + i]) filters.push(i);
      }

      this.$emit('updatePage', {
        statusFilters: filters,
        pageNo: vm.pagination.page,
        pageSize:
          vm.pagination.rowsPerPage < 0
            ? vm.paginatedData.total
            : vm.pagination.rowsPerPage,
        orderBy: vm.pagination.sortBy,
        descending: vm.pagination.descending,
        keyword: vm.SearchTextOrderTable,
        dealerID: vm.selectedDealer
          ? vm.selectedDealer.dealerIDno
          : !vm.filterDealerID
          ? 0
          : parseInt(vm.filterDealerID),
        orderType: vm.orderType == 'All' ? '' : vm.orderType,
        isQuote: vm.selectQuote,
      });
    },
    getTicketLink(props) {
      const zammadDeployedDate = new Date('2024-05-14T18:00:00+11:00');
      const itemDate = new Date(props.item.signedDate);
      if (itemDate >= zammadDeployedDate) {
        return (
          `https://zammad.vonex.com.au/#search/number:` +
          props.item.kayakoConversation
        );
      } else {
        return (
          'https://vonex.kayako.com/agent/conversations/' +
          props.item.kayakoConversation
        );
      }
    },
  },
  computed: {
    ...mapFeatureFlagGetters(['allFlags']),
    ...mapOrderGetters(['hasDealer', 'hasOrder', 'isSigned', 'hasAddress']),
    ...mapDealerState(['dealer']),
    isAdmin: function () {
      return this.dealer.authGroup == 'Administrators';
    },
    filteredRows: function () {
      let vm = this;
      if (!vm.orderData) return;
      let rows = vm.orderData.filter(this.isValid);

      if (vm.filterDealerID)
        return rows.filter((order) =>
          order.ubDealerID.toString().includes(vm.filterDealerID)
        );

      if (vm.orderType === 'Grenke')
        return rows.filter((order) => order.grenke === true);
      if (vm.orderType === 'Residential')
        return rows.filter((order) => order.residential === true);
      if (vm.orderType === 'Attention Required') {
        let weekAgo = new Date();
        weekAgo.setDate(weekAgo.getDate() - 7);
        vm.chk0 = true;
        vm.chk1 = true;
        vm.chk2 = false;
        vm.chk3 = false;
        vm.chk4 = false;
        vm.chk5 = false;
        return rows
          .filter((order) => order.orderStatus === 0 || order.orderStatus === 1)
          .filter((order) => new Date(order.createdDate) < weekAgo);
      }
      if (vm.orderType != 'All')
        return rows.filter(
          (order) => order.orderType.toLowerCase() == vm.orderType.toLowerCase()
        );

      if (vm.selectQuote) return rows.filter((order) => order.isQuote === true);

      return rows;
    },
  },
  watch: {
    attention: function (value) {
      if (value) {
        if (this.orderTypes.indexOf('Attention Required') === -1)
          this.orderTypes.unshift('Attention Required');
        this.orderType = 'Attention Required';
        this.pagination = {
          sortBy: 'createdDate',
          rowsPerPage: 10,
          descending: false,
        };
      } else {
        this.orderType = 'All';
        this.disabled = false;
        this.pagination = {
          sortBy: 'orderID',
          rowsPerPage: 10,
          descending: true,
        };
      }
    },
    pagination: {
      handler() {
        let vm = this;
        // const { page, rowsPerPage } = vm.pagination;
        vm.emitRequest();
      },
      deep: true,
    },
    SearchTextOrderTable(val) {
      let vm = this;
      if (val !== null) {
        if (val.length > 3 || val == '') vm.emitRequest();
      }
    },
    filterDealerID(val) {
      let vm = this;
      if (val !== null) {
        if (val.length > 3 || val == '') vm.emitRequest();
      }
    },
    orderType(val) {
      let vm = this;
      if (val !== null) {
        if (val === 'Attention Required') {
          vm.chk0 = true;
          vm.chk1 = true;
          vm.chk2 = false;
          vm.chk3 = false;
          vm.chk4 = false;
          vm.chk5 = false;
        }
        vm.emitRequest();
      }
    },
    selectQuote() {
      let vm = this;
      vm.emitRequest();
    },
    chk0() {
      let vm = this;
      vm.emitRequest();
    },
    chk1() {
      let vm = this;
      vm.emitRequest();
    },
    chk2() {
      let vm = this;
      vm.emitRequest();
    },
    chk3() {
      let vm = this;
      vm.emitRequest();
    },
    chk4() {
      let vm = this;
      vm.emitRequest();
    },
    chk5() {
      let vm = this;
      vm.emitRequest();
    },
  },
  mounted: async function () {
    let vm = this;
    if (vm.isAdmin) {
      this.orderTypes.push('Grenke');
      this.orderTypes.push('Residential');
    }

    if (1 == 1 && vm.isAdmin) {
      vm.headers.splice(2, 0, {
        text: 'Dealer id',
        align: 'right',
        sortable: false,
        value: 'true',
      });
      // vm.headers.splice(3, 0, {
      //   text: "Dealer Name",
      //   align: "right",
      //   sortable: false,
      //   value: "true"
      // });
      vm.headers.splice(8, 0, {
        text: 'Modify State',
        align: 'right',
        sortable: false,
        value: 'true',
      });
    }
    vm.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
    });

    await this.getDealerMembers()
      .then((data) => (this.dealers = data))
      .catch((err) => {
        if (!err.message.includes(401)) {
          this.$root.$alert.invoke(`${err.name}: ${err.message}`, 'error');
        }
      });
  },
};
</script>

<style></style>
